import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import ServerErrors from "components/SeverErrors";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import toast from "react-hot-toast";
import useTokenStore from "store/tokenStore";

const useSetRecommended = (book) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const history = useHistory();

	const save = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.patch(`books/set-as-recommended/${book}`);
		await queryClient.invalidateQueries("books");
		return response;
	};

	return useMutation(save, {
		onSuccess: async ({ data: body }) => {
			toast.success("Book set as recommended successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useSetRecommended;
